// constants
import ACTIONS from "../../constants/actions";

const {
  REQUEST_CREATE_REASON_LOADING,
  REQUEST_CREATE_REASON_SUCCESS,
  REQUEST_CREATE_REASON_FAIL,
} = ACTIONS;

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

export const formCreateReasonReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CREATE_REASON_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case REQUEST_CREATE_REASON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case REQUEST_CREATE_REASON_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
